import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { PublicUser } from '@sbt-web/auth';
import Header, { type StickyBannerContent } from '@sbt-web/header';
import type { ENV } from '@sbt-web/utils';
import { houstonEnvMap } from '@/shared/constants';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import useUser from '../../contexts/UserContext';
import { getCategoryForStickyBanner } from './utils/getCategoryForStickyBanner';
/* eslint-disable import/order */
import '@sbt-web/header/style';
interface Props {
  section: 'adview' | 'listing';
  theme: string;
  categorySlug?: string | string[];
  stickyBannerContent?: StickyBannerContent;
}
const themeMap = new Map<string, string>([['blueMotori', 'motori'], ['redCorporate', 'corporate'], ['greenLavoro', 'lavoro'], ['purpleImmobili', 'immobili'], ['yellowMarket', 'market']]);

/**
 * A constant for the unlogged user.
 * Using a constant reference might save re-renders.
 */
const emptyUser = new PublicUser('', '', '');
const HeaderComponent: FC<Props> = t0 => {
  const $ = _c(13);
  const {
    section,
    theme,
    categorySlug,
    stickyBannerContent
  } = t0;
  let t1;
  if ($[0] !== theme) {
    t1 = themeMap.get(theme) ?? "corporate";
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const headerTheme = t1;
  const {
    user
  } = useUser();
  let t2;
  if ($[2] !== categorySlug) {
    t2 = getCategoryForStickyBanner(categorySlug);
    $[2] = categorySlug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      hadesBase: process.env.NEXT_PUBLIC_HADES_BASE_URL,
      assetsBase: process.env.NEXT_PUBLIC_ASSETS_BASE_URL,
      baseURL: process.env.NEXT_PUBLIC_ENV_BASE_URL,
      phpBase: process.env.NEXT_PUBLIC_PHP_BASE_URL,
      reservedArea: process.env.NEXT_PUBLIC_AREARISERVATA_BASE_URL,
      shopBase: process.env.NEXT_PUBLIC_IMPRESAPIU_BASE_URL
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = user ?? emptyUser;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = houstonEnvMap.get(process.env.NEXT_PUBLIC_INTERNAL_ENVIRONMENT);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getOrCreatePulse();
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== headerTheme || $[8] !== section || $[9] !== stickyBannerContent || $[10] !== t2 || $[11] !== t4) {
    t7 = <Header section={section} categorySlug={t2} theme={headerTheme} urlPrefixes={t3} user={t4} env={t5 as ENV} pulseInstance={t6} stickyBannerContent={stickyBannerContent} />;
    $[7] = headerTheme;
    $[8] = section;
    $[9] = stickyBannerContent;
    $[10] = t2;
    $[11] = t4;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export default HeaderComponent;